import { useState } from 'react';
import { Alert } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import { Grid } from '@janus.team/janus-particles';
import * as googleLogin from 'customerView/components/GoogleSignInButton';
import { ExternalLink } from 'common/ExternalLink';

export const EnforceGoogleSignin = () => {
  const [error, setError] = useState(null);

  return (
    <>
      <Container>
        <header>
          <h1 className="py-8">Login with Google</h1>
        </header>
        {error
            && (
            <Grid className="particles--vertically-spaced">
              <Grid.Cell className="offset-md-2" md={8}>
                <p />
                <Alert className="text-center" variant="danger" error>{ error }</Alert>
              </Grid.Cell>
            </Grid>
            ) }
        <p>
          Before using Rackspace
          {' '}
          <strong>Managed Services for Google Cloud Platform</strong>
          , we require that you first:
          {' '}
        </p>
        <googleLogin.GoogleSignInButton setError={setError} />

        <ul>
          <li>
            If your company uses G Suite for collaboration or if you have an existing Google
            account tied to your work email address, use that account.
          </li>
          <li>
            Do not use your personal Gmail account.
          </li>
          <li>
            Otherwise,
            {' '}
            <ExternalLink href="https://accounts.google.com/SignUp?hl=en">
              create a Google account
            </ExternalLink>
            {' '}
            using your work email address before continuing.
          </li>
        </ul>

      </Container>
    </>
  );
};
